// utils in this file are temporary fixes to bugs that require more time/effort that we have at the moment

/**
 * Sometimes values we expect to be stringified objects are not and calling `JSON.parse` on them
 * will result in an error. If the validity of these values is out of our control, we should
 * prevent the app from crashing and return a default value.
 */
export function safelyParseContent<T = any, U = T>(data: any, defaultValue: any = null): T | U {
  try {
    // For normal strings
    if (typeof data === 'string') return JSON.parse(data) as T;
    // For objects with content key (AllessehContent)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (typeof data?.content === 'string') return JSON.parse(data.content as string) as T;
    throw new Error();
  } catch (_) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const potentiallyUnsafeToParseString = data?.content;
    /* eslint-disable-next-line no-console */
    console.log(
      'Error: Upstream data malformatted. Unable to stringify JSON, this is likely because there is no Allesseh Data for the article -',
      potentiallyUnsafeToParseString
    );
    if (defaultValue) {
      return defaultValue as U;
    }
    // For objects with content but not AllessehContent
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    return data?.attributes ? ({ data: { ...data.attributes, attributes: {} } } as U) : ({} as U);
  }
}

export const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export const isNullOrUndefined = (value: unknown): value is null | undefined => value === null || value === undefined;
